module.exports = __webpack_public_path__ + "static/media/ltl-package-gray.792ff3d1.svg";